export default __webpack_public_path__ + "static/media/ic-success.f8214b6d.svg";